var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"a"},[_c('h1',{staticClass:"text-center my-5"},[_vm._v("資料ダウンロード・リンク")]),_c('siryo-download')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }